import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-cameras-main",
    templateUrl: "./cameras.main.component.html",
    standalone: false
})
export class CamerasMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
